import { ThemeInterface } from './theme-interface';
import { defaultTheme } from './default-theme';
import { getThemeIconsLight, ThemeMap } from './theme-map';

const yurikaTheme: ThemeInterface = {
  name: ThemeMap.YURIKA,
  type: defaultTheme.type,
  styles: {
    global: [{ themeVariable: '--ion-item-background', value: 'white' }],
    brandPrimary: [
      { themeVariable: '--ion-color-brand-primary', value: '#5A287F' },
      { themeVariable: '--ion-color-brand-primary-rgb', value: '90, 40, 127' },
      { themeVariable: '--ion-color-brand-primary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-brand-primary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-brand-primary-shade', value: '#4f2370' },
      { themeVariable: '--ion-color-brand-primary-tint', value: '#6b3e8c' },
    ],
    textPrimary: defaultTheme.styles.textPrimary,
    textTertiary: defaultTheme.styles.textTertiary,
    textSecondary: defaultTheme.styles.textSecondary,
    backgroundPrimary: [
      { themeVariable: '--ion-color-background-primary', value: '#F7F4F8' },
      { themeVariable: '--ion-color-background-primary-rgb', value: '247, 244, 248' },
      { themeVariable: '--ion-color-background-primary-contrast', value: '#000000' },
      { themeVariable: '--ion-color-background-primary-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-background-primary-shade', value: '#d9d7da' },
      { themeVariable: '--ion-color-background-primary-tint', value: '#f8f5f9' },
    ],
    backgroundSecondary: [
      { themeVariable: '--ion-color-background-secondary', value: '#3A245E' },
      { themeVariable: '--ion-color-background-secondary-rgb', value: '58, 36, 94' },
      { themeVariable: '--ion-color-background-secondary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-background-secondary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-background-secondary-shade', value: '#332053' },
      { themeVariable: '--ion-color-background-secondary-tint', value: '#4e3a6e' },
    ],
    backgroundTertiary: [
      { themeVariable: '--ion-color-background-tertiary', value: '#5A287F' },
      { themeVariable: '--ion-color-background-tertiary-rgb', value: '90, 40, 127' },
      { themeVariable: '--ion-color-background-tertiary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-background-tertiary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-background-tertiary-shade', value: '#4f2370' },
      { themeVariable: '--ion-color-background-tertiary-tint', value: '#6b3e8c' },
    ],
    subTabLabels: [
      { themeVariable: '--ion-color-sub-tab-labels', value: '#3A245E' },
      { themeVariable: '--ion-color-sub-tab-labels-rgb', value: '58,36,94' },
      // at the moment using the contrast value for the tab labels
      { themeVariable: '--ion-color-sub-tab-labels-contrast', value: '#5A287F' },
      { themeVariable: '--ion-color-sub-tab-labels-contrast-rgb', value: '90, 40, 127' },
      { themeVariable: '--ion-color-sub-tab-labels-shade', value: '#332053' },
      { themeVariable: '--ion-color-sub-tab-labels-tint', value: '#4e3a6e' },
    ],
    solar: defaultTheme.styles.solar,
    consumption: defaultTheme.styles.consumption,
    battery: defaultTheme.styles.battery,
    consumed: defaultTheme.styles.consumed,
  },
  headerLogo: {
    path: getThemeIconsLight[ThemeMap.YURIKA],
    style: {
      height: '30px',
    },
  },
  footerLogo: defaultTheme.footerLogo,
  footerColoredLogo: defaultTheme.footerColoredLogo,
  iconsSvgPath: defaultTheme.iconsSvgPath,
  chartColors: {
    primary: { value: '#FF9B00', opacValue: 'rgba(255, 155, 0, 0.4)' },
    light: { value: '#5A287F', opacValue: 'rgba(90, 40, 127, 0.4)' },
    secondary: { value: '#4696EC', opacValue: 'rgba(70, 150, 236, 0.4)' },
    tertiary: { value: '#008A32', opacValue: 'rgba(0, 178, 153, 0.4)' },

    colorFive: { value: '#7BA24B', opacValue: 'rgba(123, 162, 75, 0.4)' },
    colorSix: { value: '#3933DE', opacValue: 'rgba(57, 51, 222, 0.4)' },
    colorSeven: { value: '#2E4C68', opacValue: 'rgba(46, 76, 104, 0.4)' },
    colorEight: { value: '#6B9FAF', opacValue: 'rgba(107, 159, 175, 0.4)' },
    colorNine: { value: '#DE3355', opacValue: 'rgba(222, 51, 85, 0.4)' },
    colorTen: { value: '#96F70D', opacValue: 'rgba(150, 247, 13, 0.4)' },
  },
  vppChartColors: defaultTheme.vppChartColors,
  streamChartColor: '#5A287F',
  buttons: {
    primary: [
      { themeVariable: '--ion-color-button-primary', value: '#5A287F' },
      { themeVariable: '--ion-color-button-primary-rgb', value: '90, 40, 127' },
      { themeVariable: '--ion-color-button-primary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-button-primary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-button-primary-shade', value: '#4f2370' },
      { themeVariable: '--ion-color-button-primary-tint', value: '#6b3e8c' },
    ],
    secondary: [
      { themeVariable: '--ion-color-button-secondary', value: '#5A287F' },
      { themeVariable: '--ion-color-button-secondary-rgb', value: '90, 40, 127' },
      { themeVariable: '--ion-color-button-secondary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-button-secondary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-button-secondary-shade', value: '#4f2370' },
      { themeVariable: '--ion-color-button-secondary-tint', value: '#6b3e8c' },
    ],
    success: [
      { themeVariable: '--ion-color-success', value: '#7BB26A' },
      { themeVariable: '--ion-color-success-rgb', value: '123, 178, 106' },
      { themeVariable: '--ion-color-success-contrast', value: '#000000' },
      { themeVariable: '--ion-color-success-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-success-shade', value: '#6c9d5d' },
      { themeVariable: '--ion-color-success-tint', value: '#88ba79' },
    ],
    warning: [
      { themeVariable: '--ion-color-warning', value: '#DB8E33' },
      { themeVariable: '--ion-color-warning-rgb', value: '219, 142, 51' },
      { themeVariable: '--ion-color-warning-contrast', value: '#000000' },
      { themeVariable: '--ion-color-warning-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-warning-shade', value: '#c17d2d' },
      { themeVariable: '--ion-color-warning-tint', value: '#df9947' },
    ],
    danger: [
      { themeVariable: '--ion-color-danger', value: '#BE3A32' },
      { themeVariable: '--ion-color-danger-rgb', value: '190, 58, 50' },
      { themeVariable: '--ion-color-danger-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-danger-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-danger-shade', value: '#a7332c' },
      { themeVariable: '--ion-color-danger-tint', value: '#c54e47' },
    ],
    successLite: [
      { themeVariable: '--ion-color-success-lite', value: '#D4F2E0' },
      { themeVariable: '--ion-color-success-lite-rgb', value: '212, 242, 224' },
      { themeVariable: '--ion-color-success-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-success-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-success-lite-shade', value: '#bbd5c5' },
      { themeVariable: '--ion-color-success-lite-tint', value: '#d8f3e3' },
    ],
    warningLite: [
      { themeVariable: '--ion-color-warning-lite', value: '#FEEACB' },
      { themeVariable: '--ion-color-warning-lite-rgb', value: '254, 234, 203' },
      { themeVariable: '--ion-color-warning-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-warning-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-warning-lite-shade', value: '#e0ceb3' },
      { themeVariable: '--ion-color-warning-lite-tint', value: '#feecd0' },
    ],
    dangerLite: [
      { themeVariable: '--ion-color-danger-lite', value: '#FFDFDF' },
      { themeVariable: '--ion-color-danger-lite-rgb', value: '255, 223, 223' },
      { themeVariable: '--ion-color-danger-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-danger-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-danger-lite-shade', value: '#e0c4c4' },
      { themeVariable: '--ion-color-danger-lite-tint', value: '#ffe2e2' },
    ],
  },
  svgIcons: {
    primarySvg: [
      { themeVariable: '--ion-color-primary-svg', value: '#5A287F' },
      { themeVariable: '--ion-color-primary-svg-rgb', value: '90, 40, 127' },
      { themeVariable: '--ion-color-primary-svg-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-primary-svg-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-primary-svg-shade', value: '#4f2370' },
      { themeVariable: '--ion-color-primary-svg-tint', value: '#6b3e8c' },
    ],
  },
  tablesRow: {
    primaryTile: [
      { themeVariable: '--ion-color-table-primary-tile', value: '#F7F4F8' },
      { themeVariable: '--ion-color-table-primary-tile-rgb', value: '247, 244, 248' },
      { themeVariable: '--ion-color-table-primary-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-primary-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-primary-tile-shade', value: '#d9d7da' },
      { themeVariable: '--ion-color-table-primary-tile-tint', value: '#f8f5f9' },
    ],
    secondaryTile: [
      { themeVariable: '--ion-color-table-secondary-tile', value: '#E8E0EB' },
      { themeVariable: '--ion-color-table-secondary-tile-rgb', value: '232, 224, 235' },
      { themeVariable: '--ion-color-table-secondary-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-secondary-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-secondary-tile-shade', value: '#ccc5cf' },
      { themeVariable: '--ion-color-table-secondary-tile-tint', value: '#eae3ed' },
    ],
    grayTile: [
      { themeVariable: '--ion-color-table-gray-tile', value: '#FBF9FC' },
      { themeVariable: '--ion-color-table-gray-tile-rgb', value: '251, 249, 252' },
      { themeVariable: '--ion-color-table-gray-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-gray-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-gray-tile-shade', value: '#dddbde' },
      { themeVariable: '--ion-color-table-gray-tile-tint', value: '#fbfafc' },
    ],
  },
};

export { yurikaTheme };
